import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/themes/light.css';

export function initializeTooltip() {
  tippy('[data-tippy-content]', {
    theme: 'light',
    animation: 'shift-away',
  });
}